<template>
  <div class="background">
    <div class="selectedTitle">
      <router-link :to="{ name:'JewelleryHome' }"><span style="padding-left: 10px">
        {{$t('mall_home.jewellery_box')}}<!-- 搜飾盒 -->
      </span></router-link>
      <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
      <span class="selectItem">
       {{$t('mall_gia_search.gia_diamond')}}<!-- GIA鑽石 -->
      </span>
    </div>
    <div class="filter_box">
      <div style="overflow:hidden">
        <div class="filter">
          <span :class="filter_type">
            {{$t('mall_gia_search.carat')}}<!-- 鑽重 -->
          </span>
          <span class="filter_row slider_row">
              <el-slider class="slider"
                         :format-tooltip="caratLimitCell"
                         :min="0" :max="100"
                         range
                         v-model="carat_limit"></el-slider>
            </span>
          <span class="filter_row range_span">
              <input style="width: 30%;"
                     v-model="params.carat.carat_min"
                     @blur="rangeChange('carat','carat_min')"
                     placeholder="0.30"><input style="width: 10%;" value="ct" readonly> -
              <input style="width: 30%;"
                     v-model="params.carat.carat_max"
                     @blur="rangeChange('carat','carat_max')"
                     placeholder="10.00"><input style="width: 10%;" value="ct" readonly>
            </span>
        </div>
        <div class="filter">
          <span :class="filter_type">
            {{$t('mall_gia_search.price')}}<!-- 價格 -->
          </span>
          <span class="filter_row slider_row">
              <el-slider class="slider"
                         :format-tooltip="amountLimitCell"
                         :min="0" :max="5000"
                         range
                         v-model="amount_limit"></el-slider>
            </span>
          <span class="filter_row range_span">
              <input style="width: 5%;" value="$" readonly><input style="width: 35%;"
                                                                  v-model="params.amount.amount_min"
                                                                  @blur="rangeChange('amount','amount_min')"
                                                                  placeholder="0"> -
              <input style="width: 6%;" value="$" readonly><input style="width: 35%;"
                                                                  v-model="params.amount.amount_max"
                                                                  @blur="rangeChange('amount','amount_max')"
                                                                  placeholder="500000">
            </span>
        </div>
        <div class="filter"
             v-for="item in filterList"
             v-if="item.type_en !== 'location'"
             :key="item.id">
          <span :class="filter_type">{{ item.typeName }}</span>
          <span class="filter_row" :class="{ 'selected': params[item.type_en].indexOf(row.code_en) > -1 }"
                v-for="(row,index) in item.extra"
                :key="index" @click="selectFilter(item.type_en,row.code_en)">
                <img class="shapeImg" v-if="item.type_en === 'shape'" :src="row.code_en | giaShape" alt="">
                <span v-else>{{ row.name }}</span>
              </span>
        </div>
        <div class="filter">
          <span :class="filter_type">
          {{$t('mall_gia_search.certificate')}}<!-- 證書 --></span>
          <span class="filter_row filter_row_gia" style="cursor: default; padding: 7px 0">GIA</span>
          <span :class="filter_type" style="flex: 2; text-align: center">
          {{$t('mall_gia_search.certificate_num')}}<!-- 證書編號 --></span>
          <input class="filter_row" type="text" :placeholder="$t('mall_gia_search.search_certificate_num')" style="flex: 2; cursor: auto;"
                 v-model="params.cert_no" @keyup.enter="getGIAData">
          <span class="filter_row" style="opacity: 0"></span>
        </div>
        <div class="filter"
             v-if="filterList[filterList.length - 1] && filterList[filterList.length - 1].type_en === 'location'"
             :key="filterList[filterList.length - 1].id">
          <span :class="filter_type" style="width: 70px">{{ filterList[filterList.length - 1].typeName }}</span>
          <span class="filter_row" :class="{ 'selected': params[filterList[filterList.length - 1].type_en].indexOf(row.code_en) > -1 }"
                style="flex: none; width: 105px"
                v-for="(row,index) in filterList[filterList.length - 1].extra"
                :key="index" @click="selectFilter(filterList[filterList.length - 1].type_en,row.code_en)">
                <span>{{ row.name === 'HONGKONG'
                  ? $t('mall_gia_search.hk')
                  : $t('mall_gia_search.foreign') }}</span>
          </span>
        </div>
      </div>
      <div class="searchDiv"
           :style="(filterList[filterList.length - 1] && filterList[filterList.length - 1].type_en === 'location') ? 'margin-top: -50px' : ''">
        <button class="reset_button" @click="resetFilter">
          {{$t('mall_gia_search.reset')}}<!-- 重置 -->
        </button>
        <button class="search_button" @click="getGIAData">
          {{$t('mall_gia_search.search')}}<!-- 搜索 -->
        </button>
      </div>
    </div>
    <div class="imgBottom" style="text-align: center;"><img src="@/assets/img/gia/gia_filter_bottom.png"></div>

    <div class="content">
      <div class="tableDiv">
        <el-table
          min-height="700"
          v-loading="loading"
          :element-loading-text="$t('mall_gia_search.loading')"
          :empty-text="$t('mall_gia_search.no_more')"
          :data="tableData"
          @row-click="giaDetail"
          @sort-change="sortChange">
          <el-table-column align="center" type="index" :width="rowWidth">
          </el-table-column>
          <el-table-column align="center" prop="carat" :label="$t('mall_gia_search.carat')" :width="rowWidth">
            <template slot-scope="scope">{{scope.row.carat}}ct</template>
          </el-table-column>
          <el-table-column align="center" prop="shape" :label="$t('mall_gia_search.shape')" :width="rowWidth">
            <template slot-scope="scope">
              <img :src="scope.row.shape.toUpperCase() | giaShape" class="shapeImg">
            </template>
          </el-table-column>
          <el-table-column align="center" prop="color" :label="$t('mall_gia_search.color')" :width="rowWidth">
            <template slot-scope="scope">{{ scope.row.color ?  scope.row.color : '-' }}</template>
          </el-table-column>
          <el-table-column align="center" prop="clarity" :label="$t('mall_gia_search.clarity')" :width="rowWidth" sortable="custom">
            <template slot-scope="scope">{{ scope.row.clarity ?  scope.row.clarity : '-' }}</template>
          </el-table-column>
          <el-table-column align="center" prop="cut" :label="$t('mall_gia_search.cut')" :width="rowWidth" sortable="custom">
            <template slot-scope="scope">{{ scope.row.cut ?  scope.row.cut : '-' }}</template>
          </el-table-column>
          <el-table-column align="center" prop="polish" :label="$t('mall_gia_search.polish')" :width="rowWidth">
            <template slot-scope="scope">{{ scope.row.polish ?  scope.row.polish : '-' }}</template>
          </el-table-column>
          <el-table-column align="center" prop="symmetry" :label="$t('mall_gia_search.symmetry')" :width="rowWidth">
            <template slot-scope="scope">{{ scope.row.symmetry ? scope.row.symmetry : '-' }}</template>
          </el-table-column>
          <el-table-column align="center" prop="fluorescent" :label="$t('mall_gia_search.fluorescent')" :width="rowWidth">
            <template slot-scope="scope">{{ scope.row.fluorescent ? scope.row.fluorescent : '-' }}</template>
          </el-table-column>
          <el-table-column align="center" prop="location" :label="$t('mall_gia_search.location')" :width="rowWidth">
            <template slot-scope="scope">{{
              scope.row.location==='HONGKONG' ? $t('mall_gia_search.hk') : $t('mall_gia_search.foreign') }}</template>
          </el-table-column>
          <el-table-column align="center" prop="amount" :label="$t('mall_gia_search.price')" :width="rowWidth" sortable="custom">
            <template slot-scope="scope">${{scope.row.amount|PriceFormat}}</template>
          </el-table-column>
          <el-table-column align="center" :label="$t('mall_gia_search.option')" width="200">
            <el-button class="view_button" type="text">
              {{$t('mall_gia_search.check')}} <!-- 立即查看 -->
            </el-button>
          </el-table-column>
        </el-table>
        <div v-show="!loading" class="pagination-container" ref="my_bottom">
          <el-pagination
            style="text-align: center"
            background
            layout="total, prev, pager, next"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            :total="pagination.total">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import NumberFormat from '@/assets/js/NumFormat';
  import PriceFormat from '@/assets/js/PriceFormat';
  import qs from "qs";

  export default {
    name: "Search",
    data() {
      return {
        rowWidth: 92,
        area: process.env.AREA,
        pagination: {
          per_page: 1,
          total: 100,
        },
        tableData: [
          {
            carat: 0.3,
            shape: 'ROUND',
            color: 'E',
            cut: 'EX',
            clarity: 'SI1',
            polish: 'EX',
            symmetry: 'EX',
            fluorescent: 'EX',
            location: '香港',
            amount: 24300,
          }
        ],
        loading: false,
        type: '',
        filterList: [],
        carat_limit: [0, 100],
        amount_limit: [0, 9999],
        params: {
          cert_no: '',
          per_page: 10,
          page: 1,
          sort_by: '',
          sort_direction: 'asc',
          product_type: [],
          promotion_type: [],
          shape: [],
          color: [],
          clarity: [],
          cut: [],
          polish: [],
          symmetry: [],
          fluorescent: [],
          location: [],
          carat: [],
          amount: []
        },
        filter_type:this.$i18n.locale === 'en'?'filter_type_en':'filter_type_hk',
        tableBottomSpan: null
      }
    },
    computed: {
      slideCaratLimit() {
        return this.carat_limit;
      },
      slideAmountLimit() {
        return this.amount_limit;
      },
      // rangeLimit() {
      //   return this.params.carat.carat_min;
      // }
    },
    filters: {
      giaShape(code_name) {
        return require("@/assets/img/gia/" + code_name + ".png");
      },
      PriceFormat(val) {
        return PriceFormat(val);
      }
    },
    watch: {
      slideCaratLimit() {
        this.params.carat.carat_min = NumberFormat(this.carat_limit[0] / 10);
        this.params.carat.carat_max = NumberFormat(this.carat_limit[1] / 10);
      },
      slideAmountLimit() {
        this.params.amount.amount_min = NumberFormat(this.amount_limit[0] * 100, '00');
        this.params.amount.amount_max = NumberFormat(this.amount_limit[1] * 100, '00');
      }
    },
    methods: {
      giaDetail(row, column, event) {
        console.log(row.stock_id);
        let routeData = this.$router.resolve({
          name: 'GIADetail',
          query: {
            id: row.stock_id
          }
        });
        window.open(routeData.href, '_blank');
      },
      getFilter() {
        this.type = 'gia';
        this.$axios.get('/app_v1/diamond_searchs_list', {}).then(res => {
          var caratIndex;
          this.filterList = res.data.data;//toUpperCase()
          this.filterList.map((type, index) => {
            if (type.type_en === 'carat') {
              caratIndex = index;
            }
            type.typeName = type.type;
            type.extra.map(row => {
              row.name = row.code_en;
              row.name = row.name ? row.name : row.code_en;
            });
          });
          caratIndex && this.filterList.splice(caratIndex, 1);
        });
      },
      resetFilter() {
        this.carat_limit = [0, 100];
        this.amount_limit = [0, 9999];
        this.params = {
          cert_no: '',
          per_page: 10,
          page: 1,
          sort_by: this.params.sort_by,
          sort_direction: this.params.sort_direction,
          product_type: [this.type],
          promotion_type: [this.type],
          shape: [],
          color: [],
          clarity: [],
          cut: [],
          polish: [],
          symmetry: [],
          fluorescent: [],
          location: [],
          carat: {
            carat_min: '0.00',
            carat_max: '10.00',
          },
          amount: {
            amount_min: 0,
            amount_max: 500000,
          }
        };
        this.getGIAData();
      },
      rangeChange(type, prop) {
        var format = (type === 'carat') ? '.00' : '00';
        this.params[type][prop] = NumberFormat(this.params[type][prop], format);
        prop === 'carat_min' && (this.carat_limit = [this.params[type][prop] * 10, this.carat_limit[1]]);
        prop === 'carat_max' && (this.carat_limit = [this.carat_limit[0], this.params[type][prop] * 10]);
        prop === 'amount_min' && (this.amount_limit = [this.params[type][prop] / 100, this.amount_limit[1]]);
        prop === 'amount_max' && (this.amount_limit = [this.amount_limit[0], this.params[type][prop] / 100]);
      },
      caratLimitCell(val) {
        return NumberFormat(val / 10) + ' ct';
      },
      amountLimitCell(val) {
        return NumberFormat(val * 100, '00') + ' HKD';
      },
      handleSizeChange(val) {
        this.params.per_page = val;
        this.getGIAData();
      },
      handlePageChange(val) {
        this.params.page = val;
        this.getGIAData();
      },
      sortChange(column) {
        this.params.sort_by = column.prop;
        this.params.sort_direction = (column.order === 'ascending') ? 'asc' : 'desc';
        this.getGIAData();
      },
      getGIAData() {
        this.loading = true;
        this.$axios.post('api/app_v1/gia/filters', this.params).then(res => {
          this.loading = false;
          this.tableData = res.data.data;
          if (res.data.data[0]) {
            this.pagination.total = res.data.data[0]['total'];
          } else {
            this.pagination.total = 0;
          }
          var str = this.$t('mall_gia_search.have')+this.pagination.total + this.$t('mall_gia_search.items')
          this.tableBottomSpan.innerHTML = str;
          console.log('pagination.total', this.pagination.total);
        });
      },
      selectFilter(type, row) {
        var index = this.params[type].indexOf(row);
        if (index < 0) {
          this.params[type].push(row);
        } else {
          this.params[type].splice(index, 1);
        }
      },
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true);
      this.tableBottomSpan = document.querySelector('.pagination-container').querySelector('span');
    },
    created() {
      this.getFilter();
      this.resetFilter();
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll, true);   //  離開頁面清除（移除）滾輪滾動事件
    },
  }
</script>

<style lang="less" scoped>
  body {
    overflow-x: hidden;
  }

  .tableDiv {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }

  .imgBottom > img {
    width: 1208px;
    margin: 0 auto;
  }

  .background {
    width: 100%;
    background: #F5F5F5;
  }

  .selectedTitle {
    width: 1200px;
    margin: 0 auto;
    color: #7A7977;
    font-size: 12px;
    padding: 15px 0 15px 0;
  }

  .selectedTitle span {
    color: #7A7977;
  }

  .selectItem {
    color: #1E1303 !important;
  }

  .selectedTitle > img {
    width: 9px;
    height: 9px;
  }

  .filter_box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    background: white;
    padding: 20px;
  }

  .content {
    width: 100%;
    margin: 16px auto;
    background: white;
  }

  .filter {
    display: -webkit-flex;
    display: flex;
    width: 50%;
    float: left;
    text-align: left;
    margin-bottom: 10px;
    padding-left: 16px;
    box-sizing: border-box;
    cursor: default;
    height: 36px;
  }

  .filter > span {
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 5px;
  }

  .filter > span > span {
    display: inline-block;
    padding: 7px 0;
  }

  .filter > span > img {
    display: block;
    padding: 1px 0;
    margin: 0 auto;
    max-height: 34px;
    box-sizing: border-box !important;
  }

  .filter_type_hk {
    padding: 5px 0;
    width: 50px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(62, 60, 57, 1);
    text-align: left;
  }

  .filter_type_en {
    padding: 5px 0;
    width: 90px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(62, 60, 57, 1);
    text-align: left;
  }

  .filter_carat {
    font-size: 14px;

  }

  .filter_row {
    -webkit-flex: 1;
    flex: 1;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 2px;
    border: 1px solid rgba(210, 210, 210, 1);
    color: rgba(62, 60, 57, 1);
    text-align: center;
  }

  .filter_row:hover {
    opacity: 0.8;
    cursor: pointer;
  }

  .filter_row_gia:hover {
    opacity: 1;
  }

  .slider_row {
    border: 1px solid transparent;
    flex: 3;
  }

  .slider {
    width: 93%;
    display: inline-block;
    margin-top: -4px;
  }

  .range_span {
    box-shadow: 0 2px 4px 0 rgba(173, 173, 173, 0.5);
    flex: 1;
    padding: 7px 0;
  }

  .range_span input {
    border-bottom: 1px solid #CDCDCD;
    text-align: center;
  }

  .shapeImg {
    max-height: 32px;
    max-width: 41px;
  }

  .selected {
    color: #FFF;
    background: #F7E7BC;
  }

  .searchDiv {
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
  }

  .searchDiv button {
    font-size: 16px;
    width: 166px;
    height: 50px;
    border-radius: 4px;
    border: 1px solid #1E1303;
    cursor: pointer;
    font-family: "PingFang SC";
  }

  .searchDiv button:hover {
    opacity: 0.8;
  }

  .search_button {
    color: #FFF;
    background: #1E1303;
  }

  .reset_button {
    color: #1E1303;
    background: white;
    margin-right: 30px;
  }

  .view_button {
    width: 142px;
    height: 40px;
    margin: 10px;
    background: rgba(241, 241, 241, 1);
    color: #1E1303
  }

  .view_button:hover {
    background: #FFF;
  }

  /deep/ .el-table td {
    padding: 0 !important;
  }

  /deep/ .el-pagination.is-background .el-pager li {
    font-size: 16px;
    height: 40px;
    padding: 6px 0;
    background: none;
    border: 1px solid rgba(221, 221, 221, 1);
    width: 50px;
    margin: 0;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.active):hover {
    color: #606266;
    background: #f4f4f5;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #1E1303;
  }

  /deep/ .el-pagination.is-background .btn-prev {
    font-size: 16px;
    width: 50px;
    height: 40px;
  }

  /deep/ .el-pagination.is-background .btn-next {
    font-size: 16px;
    width: 50px;
    height: 40px;
  }

  /deep/ .el-pagination__total, .el-pagination__sizes {
    padding: 6px 0;
    font-size: 16px !important;
  }

  /deep/ .el-pagination__sizes .el-input .el-input__inner:hover {
    border-color: #1E1303;
  }

  /deep/ .el-slider__button-wrapper {
    z-index: 2;
    /*transition: all .1s;*/
  }

  /deep/ .el-select-dropdown__item.selected {
    color: #1E1303;
  }

  /deep/ .el-slider__button {
    width: 21px;
    height: 18px;
    background: url(../../assets/img/gia/gia_slide.png) no-repeat;
    background-size: 21px 18px;
    border: none;
    overflow: unset;
  }

  /deep/ .el-slider__bar {
    background-color: #FAE9BE;
    background-image: linear-gradient(to right, #f4fff0, #FAE9BE);
    transition: all .3s;
  }

  /deep/ .el-table__body tr:hover > td {
    background-color: #F7E7BC !important;
  }

  /deep/ .el-button--text:hover {
    color: #1E1303;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/GIASearch.vue